export interface BasePcList {
  id: string; // 标识 id
  name: string; // 路由 name
  path: string; // 路由 path
  desc?: string; // 描述
  link?: string; // 只需 pc
  macUrl?: string; // 只需 mac
  pcLink?: string; // 需要多个下载 pc
  azLink?: string; // 需要多个下载 az
  iosLink?: string; // 需要多个下载 ios
  iosImgLink?: string;
  macLink?: string; // 需要多个下载 ios
  hosLink?: string; // 需要多个下载 hos
  sendAplus?: boolean; // 需要发送(window as any).aplus_queue
  isRequest?: boolean; // 需要百度转化API上报
  isSougouJs?: boolean; // 需要发送搜狗js
  isBaiduApiToken?: string; // 需要百度上报apitoken拼接
  IDX?: number; // 类型1 代表360 不传则是百度 后面又其他的再新增类型
  key?: string; // 需要360上报api拼接  msclk-微软 yklk-优酷
  Secret?: string; // 需要360上报api拼接
  collectMsclkId?: boolean; // 需要微软上报id
  collectYKlkId?: boolean; // 需要优酷上报id
  bingType?: number; // 微软上报type区分
}

export const basePcList: BasePcList[] = [
  {
    id: "1",
    name: "360",
    path: "/360",
    pcLink: "//static.dhsf.996box.com/box/channel_app/996boxSetup@6116.exe",
    azLink: "/static/img/baseImg/download/360_download_android.png",
    hosLink: "/static/img/baseImg/download/360_download_android.png",
    iosLink: "/static/img/baseImg/download/base_download_ios.png",
    macLink: "/static/img/baseImg/download/sougou_download_android.png",
    macUrl:
      "//static.dhsf.996box.com/box/channel_app/73B779C9142708A180B324799346DC1B.dmg",
    sendAplus: true,
  },
  {
    id: "4",
    name: "sougou",
    path: "/sougou",
    pcLink: "//static.dhsf.xqhuyu.com/box/channel_app/996boxSetup@6014.exe",
    azLink: "/static/img/baseImg/download/sougou_download_android.png",
    hosLink: "/static/img/baseImg/download/sougou_download_android.png",
    iosLink: "/static/img/baseImg/download/sougou_download_android.png",
    macLink: "/static/img/baseImg/download/sougou_download_android.png",
    macUrl:
      "//static.dhsf.996box.com/box/channel_app/73B779C9142708A180B324799346DC1B.dmg",
  },
  {
    id: "37",
    name: "biying",
    path: "/biying",
    pcLink: "//static.dhsf.996box.com/box/channel_app/996boxSetup@6112.exe",
    iosLink: "/static/img/baseImg/download/base_download_ios.png",
    hosLink: "/static/img/baseImg/download/360_download_android.png",
    macLink: "/static/img/baseImg/download/sougou_download_android.png",
    macUrl:
      "//static.dhsf.996box.com/box/channel_app/73B779C9142708A180B324799346DC1B.dmg",
  },
  {
    id: "45",
    name: "nami",
    path: "/nami",
    pcLink:
      "//static.dhsf.996box.com/box/channel_app/996box441SetupSigned@6145.exe",
    azLink: "/static/img/baseImg/download/nami_download_android.png",
    hosLink: "/static/img/baseImg/download/360_download_android.png",
    iosLink: "/static/img/baseImg/download/base_download_ios.png",
    macLink: "/static/img/baseImg/download/sougou_download_android.png",
    macUrl:
      "//static.dhsf.996box.com/box/channel_app/73B779C9142708A180B324799346DC1B.dmg",
    sendAplus: true,
  },
  {
    id: "42",
    name: "biyingjjs",
    path: "/biyingjjs",
    pcLink:
      "//static.dhsf.996box.com/box/channel_app/996box390SetupSigned@6124.exe",
    azLink: "/static/img/baseImg/download/360_download_android.png",
    hosLink: "/static/img/baseImg/download/360_download_android.png",
    iosLink: "/static/img/baseImg/download/base_download_ios.png",
    macLink: "/static/img/baseImg/download/sougou_download_android.png",
    macUrl:
      "//static.dhsf.996box.com/box/channel_app/73B779C9142708A180B324799346DC1B.dmg",
    collectMsclkId: true,
    bingType: 2,
    IDX: 1,
    key: "msclk",
    Secret: "2",
  },
];
